export default "__VITE_ASSET__d3MGqvBl__"